var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#" + _vm.clipId + ")" } }, [
        _c("path", {
          attrs: {
            d: "M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675",
            stroke: _vm.color,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        _c("path", {
          attrs: {
            d: "M9.33331 4.66675H14V9.33341",
            stroke: _vm.color,
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: _vm.clipId } }, [
          _c("rect", { attrs: { width: "16", height: "16", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }